import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import { i18n } from "@/i18n/config"
import Vant from "vant"
import { Lazyload } from 'vant';
import imgLazyLoad from "@/utils/imgLazyLoad"
import "vant/lib/index.css"
import "@/assets/css/common.css"
import { LOCAL_STORE } from "./config/constConfig"
import { addTimer, removeTimer } from "./handle/timerHandle"
import { autoRegistration } from "./handle/loginHandle"
import { getCookie } from "./utils/function"
import { getAdjustData, getClipBoardData, getGoogleId, getPackageName } from "./handle/chcpHandle"

let app = createApp(App).use(store)
    .use(router)
    .use(i18n)
    .use(Lazyload)
    .use(imgLazyLoad)
    .use(Vant)

let w: any = window;

const VEST_LINKS = w.VEST_LINKS;

w.createAppMain = function() {
    let userInfo: any = localStorage.getItem(LOCAL_STORE.USER_INFO);
    if (!userInfo) {
        initAndroidData();
    } else {
        userInfo = JSON.parse(userInfo);
        userInfo.isLogin==1?"":initAndroidData();
    }
    startApp();
}

function startApp() {
    let userLoginInfoStr = localStorage.getItem(LOCAL_STORE.USER_INFO);
    if (userLoginInfoStr && userLoginInfoStr != '') {
        try {
            let loginInfo: any = JSON.parse(userLoginInfoStr);
            store.state.isLogin = loginInfo.isLogin;
            store.state.userId = loginInfo.userId;
            store.state.nickName = loginInfo.nickName;
            store.state.token = loginInfo.token;
            store.state.userType = loginInfo.userType;
        } catch (e) {
            console.log(e);
        }
    }
    app.mount('#app');
}

/**初始化android数据 */
function initAndroidData() {
    if (process.env.VUE_APP_ISAPP == "true") {  //app需要获取adjust数据 并传给服务器
        let index = 0;
        addTimer("getAdjust", ()=> {
            index += 1000;
            initApkData();
            if (index >= 3000) {
                removeTimer("getAdjust");
                autoRegistration()
            }
        }, 1000);
    } else {
        let tempWidowUrl = window.location.href;
        for (var key in VEST_LINKS) {
            if (tempWidowUrl.indexOf(key) != -1) {
                let index = 0;
                addTimer("getAdjust", ()=> {
                    index += 1000;
                    initPackageData(key);
                    if (index >= 3000) {
                        removeTimer("getAdjust");
                        autoRegistration()
                    }
                }, 1000);
                return ;
            }
        }
        setTimeout(() => {
            autoRegistration();
        }, 3000);
    }
}

/**初始化apk数据 */
async function initApkData() {
    let adjustData = localStorage.getItem(LOCAL_STORE.ADJUST_DATA);
    let googleId = localStorage.getItem(LOCAL_STORE.GOOGLE_ID);
    let packageName = localStorage.getItem(LOCAL_STORE.PACKAGE_NAME);
    let clipboardData = localStorage.getItem(LOCAL_STORE.CLIPBOARD_DATA);
    if (!adjustData) {
        getAdjustData();
    }
    if (!googleId) {
        getGoogleId();
    }
    if (!packageName) {
        getPackageName();
    }
    if (!clipboardData) {
        getClipBoardData();
    }
}

/**‘初始化马甲包数据 */
function initPackageData(key: string) {
    let googleId = localStorage.getItem(LOCAL_STORE.GOOGLE_ID);
    let packageName = localStorage.getItem(LOCAL_STORE.PACKAGE_NAME);

    if (!googleId) {
        let tempGoogleId = getCookie("google_ad_id");
        console.log("google_ad_id:========>>", tempGoogleId);
        if (tempGoogleId) {
            localStorage.setItem(LOCAL_STORE.GOOGLE_ID, tempGoogleId);
        }
    }
    if (!packageName) {
        let tempName = VEST_LINKS[key];
        console.log("tempName:========>>", tempName);
        if (tempName) {
            localStorage.setItem(LOCAL_STORE.PACKAGE_NAME, tempName);
        }
    }
    return false;
}